import { render, staticRenderFns } from "./HowToHome.vue?vue&type=template&id=551ec7b8&scoped=true"
var script = {}
import style0 from "./HowToHome.vue?vue&type=style&index=0&id=551ec7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ec7b8",
  null
  
)

export default component.exports